export class ResilienceUtil {
    static rendreResilientSiProbleme(nomLibrairieJS, callback) {
        try {
            callback();
        } catch (e) {
            console.warn(`La librairie ${nomLibrairieJS} est en problème.`);
        }
    }
}
